export var createFitIntoViewHandler = function (fitIntoView) { return function () {
    fitIntoView();
}; };
